<div mat-dialog-content style="height: calc(100% - 40px);">
  <span class="tag-item" stopPropagation *ngFor="let i of items">
    {{ displayCaption(i) }}
  <i class="fal fa-times"
     stopPropagation
     (click)="removeItem(i)"></i>
  </span>
</div>
<div mat-dialog-actions style="display: flex;" >
  <button mat-stroked-button [matDialogClose] style="margin-right: auto;" >Cancel</button>
  <button mat-raised-button (click)="clear()" >Remove All</button>
  <button mat-raised-button color="primary" (click)="save()">Ok</button>
</div>
